(function () {
  var MAX_REVIEWS = 8;
  var PRIMARY_SELECTOR = ".jb-review-fallback__primary .jdgm-testimonials-carousel";
  var SOURCE_SELECTOR = ".jb-review-fallback__source .jdgm-testimonials-carousel";
  var CARD_SELECTOR = ".jdgm-testimonials-container > .jdgm-card";
  var FALLBACK_CLASS = "jdgm-card--broader";
  var queued = false;
  var merging = false;
  var lastSignature = "";

  function normalizeText(value) {
    return (value || "").replace(/\s+/g, " ").trim();
  }

  function reviewKey(card) {
    var reviewId = card.getAttribute("data-review-id");
    if (reviewId) return "id:" + reviewId;

    var reviewText = card.querySelector(".jdgm-text");
    var reviewer = card.querySelector(".jdgm-reviewer-name");
    return "text:" + normalizeText(reviewText && reviewText.textContent) + "|" + normalizeText(reviewer && reviewer.textContent);
  }

  function starCount(card) {
    return card.querySelectorAll(".jdgm-stars .jdgm-star.jdgm--on").length;
  }

  function compareByRatingDescending(a, b) {
    return starCount(b) - starCount(a);
  }

  function isEligibleBroaderReview(card) {
    var productLink = card.querySelector(".jdgm-product-name a");
    var verified = card.querySelector(".jdgm-reviewer-verified-icon");
    var reviewText = card.querySelector(".jdgm-text");
    var stars = starCount(card);
    var normalizedProductName = normalizeText(productLink && productLink.textContent).toLowerCase();
    var normalizedReviewText = normalizeText(reviewText && reviewText.textContent).toLowerCase();
    var repeatsOnlyProductName =
      normalizedProductName && normalizedReviewText === normalizedProductName;

    return !!productLink && !!verified && stars >= 4 && !repeatsOnlyProductName;
  }

  function addOriginLabel(card) {
    var productName = card.querySelector(".jdgm-product-name");
    var sourceLink = productName && productName.querySelector("a");
    var cardContent = card.querySelector(".jdgm-card-content");
    if (!sourceLink || !cardContent) return false;

    var origin = document.createElement("div");
    origin.className = "jb-review-fallback__origin";

    var prefix = document.createElement("span");
    prefix.textContent = "Review for: ";
    origin.appendChild(prefix);

    var link = sourceLink.cloneNode(true);
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
    origin.appendChild(link);

    var ratingSection = cardContent.querySelector(".jdgm-rating-section");
    cardContent.insertBefore(origin, ratingSection || null);
    productName.remove();
    return true;
  }

  function prepareCard(card, index, active) {
    card.setAttribute("data-card-index", String(index));
    card.classList.toggle("active", active);
    card.setAttribute("aria-hidden", active ? "false" : "true");

    if (active) {
      card.removeAttribute("inert");
    } else {
      card.setAttribute("inert", "");
    }
  }

  function moveToReview(primary, delta) {
    var container = primary.querySelector(".jdgm-testimonials-container");
    if (!container) return;

    var cards = Array.prototype.slice.call(container.querySelectorAll(":scope > .jdgm-card"));
    if (!cards.length) return;

    var activeIndex = cards.findIndex(function (card) {
      return card.classList.contains("active");
    });
    if (activeIndex < 0) activeIndex = 0;

    var nextIndex = (activeIndex + delta + cards.length) % cards.length;
    cards.forEach(function (card, index) {
      prepareCard(card, index, index === nextIndex);
    });
  }

  function ensureNavigation(primary) {
    if (primary.getAttribute("data-jb-review-navigation") === "ready") return;

    primary.addEventListener(
      "click",
      function (event) {
        var button = event.target.closest(".jdgm-arrow");
        if (!button || !primary.contains(button)) return;

        var label = button.getAttribute("aria-label") || "";
        var delta = /previous/i.test(label) ? -1 : 1;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        moveToReview(primary, delta);
      },
      true
    );

    primary.setAttribute("data-jb-review-navigation", "ready");
  }

  function sourceSectionFor(root) {
    return root.closest("section, .m-app-section, [id^='shopify-section-']") || root.parentElement;
  }

  function mergeReviews() {
    queued = false;
    if (merging) return;

    var primary = document.querySelector(PRIMARY_SELECTOR);
    var source = document.querySelector(SOURCE_SELECTOR);
    if (!primary || !source) return;

    var primaryContainer = primary.querySelector(".jdgm-testimonials-container");
    var sourceContainer = source.querySelector(".jdgm-testimonials-container");
    if (!primaryContainer || !sourceContainer) return;

    var sourceCards = Array.prototype.slice.call(sourceContainer.querySelectorAll(":scope > .jdgm-card"));
    if (!sourceCards.length) return;

    sourceCards.sort(compareByRatingDescending);

    var sourceSection = sourceSectionFor(source);
    if (sourceSection) sourceSection.setAttribute("aria-hidden", "true");

    primary.classList.remove("jdgm-hidden");
    primary.style.setProperty("display", "block", "important");
    primary.style.setProperty("visibility", "visible", "important");
    primary.style.setProperty("opacity", "1", "important");
    ensureNavigation(primary);

    var primarySection = sourceSectionFor(primary);
    if (primarySection) {
      primarySection.classList.remove("m-app-section--auto-hidden");
      primarySection.setAttribute("data-app-wrapper-state", "has-content");
    }

    var currentCards = Array.prototype.slice
      .call(primaryContainer.querySelectorAll(":scope > .jdgm-card:not(." + FALLBACK_CLASS + ")"))
      .sort(compareByRatingDescending)
      .slice(0, MAX_REVIEWS);
    var currentKeys = new Set(currentCards.map(reviewKey));
    var fallbackCards = [];

    sourceCards.some(function (card) {
      if (currentCards.length + fallbackCards.length >= MAX_REVIEWS) return true;
      if (!isEligibleBroaderReview(card)) return false;

      var key = reviewKey(card);
      if (currentKeys.has(key)) return false;

      var clone = card.cloneNode(true);
      clone.classList.add(FALLBACK_CLASS);
      clone.classList.remove("active");
      clone.removeAttribute("style");

      if (!addOriginLabel(clone)) return false;

      currentKeys.add(key);
      fallbackCards.push(clone);
      return false;
    });

    var signature = currentCards.map(reviewKey).concat(fallbackCards.map(reviewKey)).join("||");
    if (
      signature === lastSignature &&
      primaryContainer.querySelectorAll(":scope > .jdgm-card").length === currentCards.length + fallbackCards.length &&
      primaryContainer.querySelectorAll(":scope > .jdgm-card.active").length === 1
    ) {
      return;
    }

    merging = true;
    primaryContainer.querySelectorAll(":scope > ." + FALLBACK_CLASS).forEach(function (card) {
      card.remove();
    });
    currentCards.forEach(function (card) {
      primaryContainer.appendChild(card);
    });
    fallbackCards.forEach(function (card) {
      primaryContainer.appendChild(card);
    });

    var mergedCards = Array.prototype.slice.call(primaryContainer.querySelectorAll(":scope > .jdgm-card"));
    var activeIndex = mergedCards.findIndex(function (card) {
      return card.classList.contains("active");
    });
    if (activeIndex < 0 || activeIndex >= mergedCards.length) activeIndex = 0;

    mergedCards.forEach(function (card, index) {
      prepareCard(card, index, index === activeIndex);
    });

    primary.style.setProperty("--slides-count", String(mergedCards.length));
    primary.setAttribute("data-jb-review-count", String(mergedCards.length));
    primary.setAttribute("data-jb-current-product-review-count", String(currentCards.length));
    primary.setAttribute("data-jb-broader-review-count", String(fallbackCards.length));
    primary.setAttribute("data-jb-review-fallback-ready", "true");

    lastSignature = signature;
    merging = false;
  }

  function queueMerge() {
    if (queued || merging) return;
    queued = true;
    window.requestAnimationFrame(mergeReviews);
  }

  function init() {
    queueMerge();

    var observer = new MutationObserver(function () {
      queueMerge();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      queueMerge();
      if (attempts >= 60 || document.querySelector(PRIMARY_SELECTOR + "[data-jb-review-fallback-ready='true']")) {
        window.clearInterval(timer);
      }
    }, 500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
